/**
 * Percentage of settled tests that passed. Skipped and degraded tests are
 * excluded; callers include successful retries in the passed count.
 */
export function calculatePassRate(passed: number, failed: number): number | null {
  const settled = passed + failed;
  return settled > 0 ? (passed / settled) * 100 : null;
}

/** Display a percentage without rounding an imperfect result to 100%. */
export function formatPassRate(percent: number): string {
  const rounded = Number(percent.toFixed(2));
  return percent < 100 && rounded === 100 ? '<100%' : `${rounded}%`;
}
